import React from 'react';
import { FieldControlProps } from '../FieldRenderer';
import OptionButtons from './OptionButtons';

const YES_NO = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

// Always Yes/No. Stays unanswered (null) until one is picked, unless the
// report gives a default_value.
const BooleanInput: React.FC<FieldControlProps> = ({ field, value, onChange }) => (
  <OptionButtons label={field.field_label} options={YES_NO} isSelected={(v) => v === value} onPick={onChange} />
);

export default BooleanInput;
